// Add your JS customizations here
(function ($) {
	/**
	 * Service Local MENU Active判断
	 */
	$(document).ready(function () {
		$(".lnav-btn-wrap a").each(function () {
			var val = $(this).attr("href");

			if (window.location.href == val) {
				$(this).addClass("lnav-btn-wrap-active");
			}
		});
	});

	/**
	 *  Cat Active判断
	 */
	$(document).ready(function () {
		$(".archive-cat-wrap a").each(function () {
			var val = $(this).attr("href");

			if (window.location.href == val) {
				$(this).addClass("archive-cat-active");
			}
		});
	});

	/**
	 * Slick
	 */

	$(document).ready(function () {
		$(".slick-slider").slick({
			// アクセシビリティ。左右ボタンで画像の切り替えをできるかどうか
			accessibility: true,
			// 自動再生。trueで自動再生される。
			autoplay: true,
			// 自動再生で切り替えをする時間
			autoplaySpeed: 0,
			// 自動再生や左右の矢印でスライドするスピード
			speed: 20000,
			// 自動再生時にスライドのエリアにマウスオンで一時停止するかどうか
			pauseOnHover: true,
			// 自動再生時にドットにマウスオンで一時停止するかどうか
			pauseOnDotsHover: true,
			// 切り替えのアニメーション。ease,linear,ease-in,ease-out,ease-in-out
			cssEase: "linear",
			// 画像下のドット（ページ送り）を表示
			dots: false,
			// ドットのclass名をつける
			dotsClass: "slick-dots",
			// ドラッグができるかどうか
			draggable: true,
			// 切り替え時のフェードイン設定。trueでon
			fade: false,
			// 左右の次へ、前へボタンを表示するかどうか
			arrows: false,
			// 無限スクロールにするかどうか。最後の画像の次は最初の画像が表示される。
			infinite: true,
			// 最初のスライダーの位置
			initialSlide: 0,
			// 画像の遅延表示。‘ondemand’or'progressive'
			lazyLoad: "ondemand",
			// スライドのエリアにマウスオーバーしている間、自動再生を止めるかどうか。
			pauseOnHover: true,
			// スライドのエリアに画像がいくつ表示されるかを指定
			slidesToShow: 1,
			// 一度にスライドする数
			slidesToScroll: 1,
			// タッチスワイプに対応するかどうか
			swipe: true,
			// 縦方向へのスライド
			vertical: false,
			// 表示中の画像を中央へ
			centerMode: true,
			// 中央のpadding
			centerPadding: "28%",
			// レスポンシブ
			responsive: [
				{
					breakpoint: 1201,
					settings: {
						// 左右の次へ、前へボタンを表示するかどうか
						arrows: false,
						// スライドのエリアに画像がいくつ表示されるかを指定
						slidesToShow: 1,
						// 一度にスライドする数
						slidesToScroll: 1,
						// 中央のpadding
						centerPadding: "28%",
						// 無限スクロールにするかどうか。最後の画像の次は最初の画像が表示される。
						infinite: true,
						// 画像下のドット（ページ送り）を表示
						dots: false,
					},
				},
				{
					breakpoint: 993,
					settings: {
						arrows: false,
						slidesToShow: 1,
						slidesToScroll: 1,
						centerPadding: "28%",
						infinite: true,
						dots: false,
					},
				},
				{
					breakpoint: 769,
					settings: {
						arrows: false,
						slidesToShow: 1,
						slidesToScroll: 1,
						centerPadding: "10%",
						infinite: true,
						dots: false,
					},
				},
				{
					breakpoint: 577,
					settings: {
						arrows: false,
						slidesToShow: 1,
						slidesToScroll: 1,
						centerPadding: "6%",
						infinite: true,
						dots: false,
					},
				},
			],
		});

		$(".slick-slider-home-seminar").slick({
			// アクセシビリティ。左右ボタンで画像の切り替えをできるかどうか
			accessibility: true,
			// 自動再生。trueで自動再生される。
			autoplay: true,
			// 自動再生で切り替えをする時間
			autoplaySpeed: 0,
			// 自動再生や左右の矢印でスライドするスピード
			speed: 20000,
			// 自動再生時にスライドのエリアにマウスオンで一時停止するかどうか
			pauseOnHover: true,
			// 自動再生時にドットにマウスオンで一時停止するかどうか
			pauseOnDotsHover: true,
			// 切り替えのアニメーション。ease,linear,ease-in,ease-out,ease-in-out
			cssEase: "linear",
			// 画像下のドット（ページ送り）を表示
			dots: false,
			// ドットのclass名をつける
			dotsClass: "slick-dots",
			// ドラッグができるかどうか
			draggable: true,
			// 切り替え時のフェードイン設定。trueでon
			fade: false,
			// 左右の次へ、前へボタンを表示するかどうか
			arrows: false,
			// 無限スクロールにするかどうか。最後の画像の次は最初の画像が表示される。
			infinite: true,
			// 最初のスライダーの位置
			initialSlide: 0,
			// 画像の遅延表示。‘ondemand’or'progressive'
			lazyLoad: "ondemand",
			// スライドのエリアにマウスオーバーしている間、自動再生を止めるかどうか。
			pauseOnHover: true,
			// スライドのエリアに画像がいくつ表示されるかを指定
			slidesToShow: 1,
			// 一度にスライドする数
			slidesToScroll: 1,
			// タッチスワイプに対応するかどうか
			swipe: true,
			// 縦方向へのスライド
			vertical: false,
			// 表示中の画像を中央へ
			centerMode: true,
			// 中央のpadding
			centerPadding: "28%",
			// レスポンシブ
			responsive: [
				{
					breakpoint: 1201,
					settings: {
						// 左右の次へ、前へボタンを表示するかどうか
						arrows: false,
						// スライドのエリアに画像がいくつ表示されるかを指定
						slidesToShow: 1,
						// 一度にスライドする数
						slidesToScroll: 1,
						// 中央のpadding
						centerPadding: "28%",
						// 無限スクロールにするかどうか。最後の画像の次は最初の画像が表示される。
						infinite: true,
						// 画像下のドット（ページ送り）を表示
						dots: false,
					},
				},
				{
					breakpoint: 993,
					settings: {
						arrows: false,
						slidesToShow: 1,
						slidesToScroll: 1,
						centerPadding: "28%",
						infinite: true,
						dots: false,
					},
				},
				{
					breakpoint: 769,
					settings: {
						autoplaySpeed: 3000,
						speed: 400,
						autoplay: false,
						cssEase: "ease",
						arrows: true,
						slidesToShow: 1,
						slidesToScroll: 1,
						centerPadding: "6%",
						infinite: true,
						dots: true,
					},
				},
				{
					breakpoint: 577,
					settings: {
						autoplaySpeed: 3000,
						speed: 400,
						autoplay: false,
						cssEase: "ease",
						arrows: true,
						slidesToShow: 1,
						slidesToScroll: 1,
						centerPadding: "10%",
						infinite: true,
						dots: true,
					},
				},
			],
		});
	});

	/**
	 *  simpleParallax.js
	 */
	$(document).ready(function () {
		const images = document.querySelectorAll('.simple-parallax');
		new simpleParallax(images, {
			orientation: 'down',
			scale: 1.3,
			delay: 0.6,
			// transition: 'cubic-bezier(0,0,0,.1)'
		});
	});


})(jQuery);
